export default __webpack_public_path__ + "static/media/searchIcon.886fdc12.svg";